module.exports = __webpack_public_path__ + "static/img/RAWO7_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAWO7_1.png
// module id = Z4ln
// module chunks = 0